import { render, staticRenderFns } from "./InstitutionIndex.vue?vue&type=template&id=57a21e4f&scoped=true&"
import script from "./InstitutionIndex.vue?vue&type=script&lang=ts&"
export * from "./InstitutionIndex.vue?vue&type=script&lang=ts&"
import style0 from "./InstitutionIndex.vue?vue&type=style&index=0&id=57a21e4f&lang=less&scoped=true&"
import style1 from "./InstitutionIndex.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a21e4f",
  null
  
)

export default component.exports